/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contacts_NavInputs */

const id_contacts_nav = /** @type {(inputs: Contacts_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak`)
};

const en_contacts_nav = /** @type {(inputs: Contacts_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts`)
};

/**
* | output |
* | --- |
* | "Contacts" |
*
* @param {Contacts_NavInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const contacts_nav = /** @type {((inputs?: Contacts_NavInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contacts_NavInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contacts_nav(inputs)
	return id_contacts_nav(inputs)
});